'use strict';
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var performance = require('perf_hooks').performance;
var IS_LEORIC_BONE = require('../constants').IS_LEORIC_BONE;
function isPlainObject(value) {
    return Object.prototype.toString.call(value) === '[object Object]';
}
function compose() {
    var funcs = Array.from(arguments);
    if (funcs.length === 0)
        return function (arg) { return arg; };
    if (funcs.length === 1)
        return funcs[0];
    return funcs.reverse().reduce(function (a, b) { return function () {
        var arg = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arg[_i] = arguments[_i];
        }
        return b(a.apply(void 0, __spreadArray([], __read(arg), false)));
    }; });
}
function getPropertyNames(obj) {
    if (obj == null)
        return [];
    var propertyNames = [];
    // avoid to deep clone obj
    var muteObj = Object.getPrototypeOf(obj);
    do {
        propertyNames.push.apply(propertyNames, __spreadArray([], __read(Object.keys(muteObj)), false));
        muteObj = Object.getPrototypeOf(muteObj);
        // the loop while reach to Leoric#Bone, filter __proto__, Object.getPrototypeOf(Bone) = {}, ({}).constructor.name = 'Object'
    } while (muteObj && muteObj.constructor.name !== 'Object');
    // get own properties
    propertyNames.push.apply(propertyNames, __spreadArray([], __read(Object.keys(obj)), false));
    // get unique properties' names
    var propertyNamesSet = new Set(propertyNames);
    return Array.from(propertyNamesSet);
}
// microseconds to millisecond, 10.456
function calculateDuration(starttime) {
    return Math.floor((performance.now() - starttime) * 1000) / 1000;
}
var logger = {};
['log', 'warn', 'debug', 'info', 'error'].forEach(function (key) {
    logger[key] = function () {
        console[key].apply(console, __spreadArray(['[leoric]'], __read(arguments), false));
    };
});
function isBone(bone) {
    if (!bone || (typeof bone !== 'object' && typeof bone !== 'function'))
        return false;
    var metaValue = Reflect.getMetadata(IS_LEORIC_BONE, bone);
    return metaValue === true;
}
var deepClone = typeof structuredClone === 'function'
    ? structuredClone
    : function (value) { return JSON.parse(JSON.stringify(value)); };
module.exports = {
    isPlainObject: isPlainObject,
    compose: compose,
    getPropertyNames: getPropertyNames,
    calculateDuration: calculateDuration,
    logger: logger,
    isBone: isBone,
    deepClone: deepClone,
};
//# sourceMappingURL=index.js.map